import { stationList } from "constants/station";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const getStationList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.station_list(pageNum, filters);
    dispatch({ type: stationList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: stationList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const addStation = async (bodyData) => {
  try {
    const res = await api.add_station(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const editStation = async (id, bodyData) => {
  try {
    const res = await api.edit_station(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getStationDetailsById = async (id) => {
  try {
    const res = await api.get_station_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteStation = async (id) => {
  try {
    const res = await api.delete_station_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
